import { render, staticRenderFns } from "./SLoader.vue?vue&type=template&id=0dd3a9e0&scoped=true&"
import script from "./SLoader.vue?vue&type=script&lang=js&"
export * from "./SLoader.vue?vue&type=script&lang=js&"
import style0 from "./SLoader.vue?vue&type=style&index=0&id=0dd3a9e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd3a9e0",
  null
  
)

export default component.exports